import Api from "../../../utils/axios";

const YoutubeApi = {
  youtubeAuth: () => Api.get("youtube/auth-url"),
  getOauthToken: () => Api.get("youtube/oauth-get-token"),
  youtubeUpload: (payload) => Api.post("youtube/YT-upload", payload),
  ytDeleteVideo: (payload) => Api.post("youtube/YT-delete", payload),
};

export default YoutubeApi;
